import { useAuth } from "@/shared/stores/auth";
import { storeToRefs } from "pinia";
import { computed } from "vue";

export function usePermission(...userRoles: string[]) {
  const authStore = useAuth();
  const { user } = storeToRefs(authStore);

  return computed(() => {
    const currentUserRoles: string[] = user.value?.roles ?? [];

    return currentUserRoles.some((userRole: string) => userRoles.includes(userRole));
  }).value;
}
